module.exports = __webpack_public_path__ + "img/tuta-absoluta.d6b561ae.jpg";